import React from 'react';
import { Modal, Button, Alert } from 'react-bootstrap';
import { FaExclamationTriangle, FaTrash, FaTimes } from 'react-icons/fa';
import './ModernConfirmModal.css';

const ModernConfirmModal = ({
  show,
  onHide,
  onConfirm,
  title = "Konfirmasi Hapus",
  message,
  itemName,
  type = "danger",
  confirmText = "Ya, Hapus",
  cancelText = "Batalkan",
  loading = false,
  stripColor = "#dc3545",
  stripHeight = "6px"
}) => {
  return (
    <Modal 
      show={show} 
      onHide={onHide} 
      centered 
      className="modern-confirm-modal"
      backdrop="static"
    >
      {/* Border Strip */}
      <div 
        className="modal-strip"
        style={{ 
          backgroundColor: stripColor,
          height: stripHeight
        }}
      ></div>
      
      <Modal.Body className="p-0">
        <div className="confirm-content">
          {/* Header dengan icon warning */}
          <div className="confirm-header">
            <div className="confirm-icon-wrapper">
              <div className="icon-circle">
                <FaExclamationTriangle className="confirm-icon" />
              </div>
            </div>
            <h4 className="confirm-title">{title}</h4>
            <p className="confirm-subtitle">Konfirmasi Tindakan</p>
          </div>

          {/* Body dengan pesan */}
          <div className="confirm-body">
            <div className="alert-message">
              <p className="main-message">{message}</p>
              {itemName && (
                <div className="item-highlight">
                  <div className="item-name-wrapper">
                    <span className="item-label">Item:</span>
                    <strong className="item-name">"{itemName}"</strong>
                  </div>
                </div>
              )}
            </div>
            
            <Alert variant="danger" className="warning-alert">
              <div className="alert-content">
                <FaExclamationTriangle className="alert-icon" />
                <div>
                  <div className="alert-title">Tindakan tidak dapat dibatalkan!</div>
                  <div className="alert-description">
                    Data yang sudah dihapus tidak dapat dikembalikan. Pastikan ini adalah tindakan yang Anda inginkan.
                  </div>
                </div>
              </div>
            </Alert>
          </div>

          {/* Footer dengan action buttons */}
          <div className="confirm-footer">
            <div className="button-group">
              <Button
                variant="outline-secondary"
                onClick={onHide}
                disabled={loading}
                className="confirm-btn cancel-btn"
              >
                <FaTimes className="btn-icon" />
                {cancelText}
              </Button>
              <Button
                variant="danger"
                onClick={onConfirm}
                disabled={loading}
                className="confirm-btn delete-btn"
              >
                {loading ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2" />
                    Menghapus...
                  </>
                ) : (
                  <>
                    <FaTrash className="btn-icon" />
                    {confirmText}
                  </>
                )}
              </Button>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ModernConfirmModal;